import { FC } from "react";
import { isValid, parseISO, format } from "date-fns";
import { cn } from "@src/lib/utils/cn";

export type DateTimeInputType = "datetime-local" | "date";

type Props = {
  value?: Date | null | undefined;
  required?: boolean;
  onChange: (val: Date) => void;
  disabled?: boolean;
  type?: DateTimeInputType;
  min?: string;
  max?: string;
  className?: string;
};

const TYPE_TO_FORMAT: { [key: string]: string } = {
  "datetime-local": "yyyy-MM-dd'T'HH:mm",
  date: "yyyy-MM-dd",
};

const DateTimeField: FC<Props> = ({
  value,
  required,
  onChange,
  disabled = false,
  type = "datetime-local",
  min = "",
  max = "",
  className,
}) => {
  return (
    <input
      type={type}
      required={required}
      min={min}
      max={max}
      disabled={disabled}
      className={cn(
        "block h-8 px-2 font-inter font-normal text-sm text-black rounded-lg border border-gray-5-alpha bg-white outline-none cursor-text",
        "hover:border-blue-9",
        "focus:border-2 focus:border-blue-5",
        "disabled:border-gray-5-alpha disabled:bg-gray-4-alpha",
        className,
      )}
      value={fmtDateForInput(type, value)}
      onChange={(event) => {
        const dateStr = event?.target?.value;
        const newDate = parseISO(dateStr);
        if (newDate && isValid(newDate)) {
          onChange(newDate);
        }
      }}
    />
  );
};

export default DateTimeField;

export function fmtDateForInput(
  type: string,
  date?: Date | null | undefined,
): string {
  return date ? format(date, TYPE_TO_FORMAT[type]) : "";
}
